var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pagination-demo"}},[_c('pagination-default'),_c('pagination-icon'),_c('pagination-links-limit'),_c('pagination-go-to'),_c('pagination-color'),_c('pagination-programmatic-inc-dec')],1)}
var staticRenderFns = []

export { render, staticRenderFns }